import { GoodgameSignal } from "./GoodgameSignal";

/**
 *    ArraySignal
 *
 *     @author Alexander
 */

export class ArraySignal extends GoodgameSignal {
    constructor() {
        super(Array);
    }

    public signal(params: any[]): void {
        super.dispatch(params);
    }
}
